import { jsx } from 'react/jsx-runtime';
import { useLocalization } from '@shared-ui/localization-context';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSLoader } from '../loader/index.esm.js';
import styles from '../../styles/uitk-egds-loader.css';
import { classNames } from '../../utils/classnames/index.esm.js';
import { liveAnnounce, Level } from '../../utils/live-announce/index.esm.js';
const getClassNameList = classNames.bind(styles);
class PageLoader extends React.Component {
  static displayName = 'EGDSPageLoader';
  render() {
    const {
      props
    } = this;
    const baseCssClass = 'uitk-loader-page';
    const cssClassNames = getClassNameList(baseCssClass, props.className, {
      'is-visible': props.visible
    });
    const title = props.title || props.l10n.formatText('loading');
    if (props.visible) {
      liveAnnounce(title, Level.POLITE);
    }
    return jsx(EGDSLoader, {
      className: cssClassNames,
      title: title,
      "aria-hidden": !props.visible
    });
  }
}
const EGDSPageLoader = props => {
  const l10n = useLocalization();
  return jsx(PageLoader, {
    l10n: l10n,
    ...props
  });
};
export { EGDSPageLoader, PageLoader };